import { Edit, Eye, Trash } from "tabler-icons-react";

export const lookupListHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },

  //give full width to the question column
  {
    id: "lookupType",
    numeric: false,
    disablePadding: true,
    label: "Type",
  },
  {
    id: "lookupName",
    numeric: false,
    disablePadding: true,
    label: "Name",
  },

  // {
  //   id: "state",
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Status",
  // },
  // {
  //   id: "createdDate",
  //   date: true,
  //   numeric: false,
  //   disablePadding: true,
  //   label: "Created Date",
  // },
  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
